import {useTranslation} from "react-i18next";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {Link} from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";
import {MenuItem, Select} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import useResizeObserver from "../../../hooks/useResizeObserver";
import {createInstance} from "../../../../Providers/TemplateInstanceProvider";
import {getImageSize} from "../../../../../lib/common";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {formatCurrency, getBoxSize} from "../../../../../utils";
import useDebounce from "../../../hooks/useDebounce";
import {useShoppingCart} from "../../../hooks/shoppingcart";
import DrawTemplate from "../../../Components/Template/DrawTemplate";
import {Skeleton} from "@material-ui/lab";


const useStyles = makeStyles(theme => ({
    productName: {
        marginTop: 0,
        marginBottom: 0
    },
    orderPartLink: {
        display: 'flex',
        flexDirection: 'column',
        textDecoration: 'none',
        color: 'black'
    },
    selectedItem: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.8)'
    },
    titleRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
    },
    closeButton: {
        position: 'relative',
        left: theme.spacing(1),
        top: -theme.spacing(1),
        '& .MuiIcon-root': {
            fontSize: '1.2rem',
            color: theme.palette.primary.main
        }
    },
    orderPartSplit: {
        display: 'flex'
    },
    orderPartInfo: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    orderPartImageContainer: {
        overflow: 'hidden',
        position: 'relative',
        flexBasis: '40%',
        flexShrink: 0,
        backgroundColor: theme.palette.primary.light,
        marginRight: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            //paddingTop: '100%'
        }
    },
    orderPartImage: {
        display: 'block',
        paddingTop: (30 / 25 * 100) + '%',
    },
    productSelect: {
        '& .MuiSelect-root': {
            padding: theme.spacing(1),
            fontSize: '12px',
        },
        '& .MuiSelect-selectMenu': {
            whiteSpace: 'normal'
        }
    },
    subProduct: {
        fontSize: '12px',
        fontWeight: 'bold'
    },
    qtyContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    inputQty: {
        width: '36px',
        border: '1px solid ' + theme.palette.primary.main,
        height: '28px',
        borderRadius: '4px',
        marginLeft: theme.spacing(1),
        textAlign: 'center',
        fontSize: '15px',
        position: 'relative',
        backgroundColor: 'white',
        '& select': {
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            opacity: 0
        }
    },
    editButton: {
        position: 'absolute',
        right: '5px',
        bottom: '5px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '4px',
        padding: '4px',
        '& .material-icons': {
            color: theme.palette.primary.main,
            fontSize: '1.2rem'
        }
    },
    priceAndQuantityContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    priceInfo: {
        fontSize: '12px'
    },
    subTotal: {
        fontWeight: 'bold'
    },
    templateInnerContainer: {
        position: 'absolute'
    }
}));

const PhotogiftOrderLine = ({orderLine, className, onDelete, onLongPress, selectMode, isSelected, onToggleSelected}) => {
    const {t} = useTranslation();
    const {getProductByUuid } = usePriceList();
    const classes = useStyles();

    const product = useMemo(() => {
        return getProductByUuid(orderLine.product.uuid);
    }, [orderLine]);

    console.log('The product', product, orderLine);

    const handleClick = (e) => {
        if (selectMode) {
            e.preventDefault();
            onToggleSelected(e, orderLine)
        }
    }

    return <div className={`${className}`}>
            <div className={classes.orderPartSplit}>
                <div className={classes.orderPartImageContainer}>
                    <ProductPreviewTemplate orderLine={orderLine} product={product}/>
                </div>

                <div className={classes.orderPartInfo}>

                    <div className={classes.titleRow}>
                        <h4 className={classes.productName}>{orderLine.description}</h4>
                        <IconButton className={classes.closeButton} onClick={(e) => onDelete(e, orderLine)}>
                            <Icon>close</Icon>
                        </IconButton>
                    </div>

                    {product.subproducts.length > 0 && <SubProductSelect product={product} orderLine={orderLine} subProductUuids={orderLine.subProductUuids} />}

                   <ProductPriceAndQuantity product={product} orderLine={orderLine} template={orderLine.templates[0].template} />
                </div>
            </div>
        {selectMode && <div className={classes.selectedItem} />}
    </div>
}

const ProductPreviewTemplate = ({orderLine, product, handleClick}) => {
    const containerRef = useRef();
    const cs = useResizeObserver(containerRef);
    const classes = useStyles();

    console.log('Preview template', orderLine, cs)

    const templateInstance = useMemo( () => {
        const inst = createInstance(orderLine.templates[0].template);
        return {
            ...inst,
            resources: {
                ...inst.resources,
                ...orderLine.templates[0].resources,
            },
            year: orderLine.templates[0].year
        }
    }, [orderLine]);

    const style = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }

    return <Link to={`/cart/edit/${orderLine.uuid}`} className={classes.orderPartImage} onClick={handleClick}>
            <div style={style} ref={containerRef}>
                <TemplateContainer templateInstance={templateInstance} size={cs} />
            </div>
            <IconButton className={classes.editButton}>
                <Icon>edit</Icon>
            </IconButton>
        </Link>
}

const TemplateContainer = ({templateInstance, size}) => {
    const classes = useStyles();

    const [cSize, style] = useMemo(() => {
        const horizontalPadding = 6;
        const verticalPadding = 6;
        const cSize = getBoxSize('fit-in', templateInstance.template.dimensions, {
            width: size.width - (horizontalPadding * 2),
            height: size.height - (verticalPadding * 2),
        });
        const style = {
            width: cSize.width + 'px',
            height: cSize.height + 'px',
            left: cSize.x + horizontalPadding + 'px',
            top: cSize.y + verticalPadding + 'px',
        }
        return [cSize, style]
    }, [size]);

    return <div className={classes.templateInnerContainer} style={style}>
        <DrawTemplate templateInstance={templateInstance} containerSize={cSize}/>
    </div>
}

const SubProductSelect = ({product, subProductUuids, orderLine}) => {
    const classes = useStyles();
    const { updateOrderLine } = useShoppingCart()

    const handleChange = (e) => {
        updateOrderLine({
            ...orderLine,
            subProductUuids: [e.target.value]
        });
    }
    // We don't have multiple subproducts, do we?

    console.log('SubProduct', subProductUuids);

    return <FormControl fullWidth variant="filled">
        <Select
            className={classes.productSelect}
            labelId="select-sub-product"
            id="select-sub-product"
            value={subProductUuids[0]}
            size="small"
            /*renderValue={(value) => {
                return <div>
                    <div>{value}</div>
                    <div className={classes.subProduct}> - Med hvit konvolutt</div>
                </div>
            }}*/
            onChange={handleChange}
        >
            {product.subproducts.map(subproduct => {
                return <MenuItem key={subproduct.uuid} value={subproduct.uuid}>{subproduct.name}</MenuItem>
            })}
        </Select>
    </FormControl>
}

const ProductPriceAndQuantity = ({product, orderLine, template}) => {
    const classes = useStyles();
    const [t] = useTranslation();
    const { productHasCampaign, getPricePerUnit } = usePriceList();

    const hasCampaignPrice = useMemo( () => {
        for (const category of template.categories) {
            if (productHasCampaign(product, category)) {
                return true;
            }
        }
        return false;
    }, [product, template]);

    const ppu = useMemo( () => {
        let ppu = getPricePerUnit(product, orderLine.quantity, hasCampaignPrice)
        for (const subProductUuid of orderLine.subProductUuids) {
            const subproduct = product.subproducts.find(sp => sp.uuid == subProductUuid);
            console.log('Adding subproduct', subproduct)
            ppu += subproduct.extraprice;
        }
        console.log('PPU', ppu, product)
        return ppu;
    }, [orderLine]);


    //const itemPrice = product.getItemPrice();

    return <div className={classes.priceAndQuantityContainer}>
        <div className={classes.priceInfo}>
            <div>
                {t('%s each', {postProcess: 'sprintf', sprintf: [formatCurrency(ppu)]})}
            </div>
            <div className={classes.subTotal}>
                {!orderLine.updating && t('Subtotal %s', {postProcess: 'sprintf', sprintf: [formatCurrency(orderLine.actualLinePrice)]})}
                {orderLine.updating && <Skeleton variant='text' />}
            </div>
        </div>
        <div className={classes.qtyContainer}>
            <Quantity orderLine={orderLine} product={product} />
        </div>
    </div>
}

const Quantity = ({orderLine, product}) => {
    const classes = useStyles();
    const [quantity, setQuantity] = useState(orderLine.quantity);
    const { updateOrderLine } = useShoppingCart()

    useEffect(() => {
        setQuantity(() => {
            return orderLine.quantity
        })
    }, [orderLine.quantity])

    const handleChange = (e) => {
        let value = e.target.value;
        if (isNaN(value) || value < product.minorderpartquantity) {
            value = product.minorderpartquantity;
        }
        updateOrderLine({
            ...orderLine,
            quantity: value
        });
    }

    const quantityList = useMemo(() => {
        // There have to be a better way to make this?
        const options = [];
        for (let i = product.minorderpartquantity; i<(quantity+100); i++) {
            options.push(i);
        }
        return options;
    }, [quantity])

    return <button className={classes.inputQty}>
        {quantity}
        <select value={quantity} onChange={handleChange} >
            {quantityList.map (i => {
                return <option key={i} value={i}>{i}</option>
            })}
        </select>
    </button>
}

/*<input type='number' className={classes.inputQty} value={quantity}
                  min={product.minorderpartquantity} onBlur={handleBlur} onChange={e => setQuantity(e.target.value)} />*/

export default PhotogiftOrderLine;